import tutor from './tutor'
import serviceWorkOrder from './serviceWorkOrder'

export default {
  myg: {
    oneToOne: {
      ...tutor,
      ...serviceWorkOrder
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/myg/myg.js